import { toast, ToastOptions } from "react-toastify";

class Toastify {
    success(message: string, options?: ToastOptions) {
        toast.success(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            style: {
                backgroundColor: "#fff",
                color: "#000",
                boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
            },
            theme: "colored",
            ...options,
        });
    }

    error(message: string, options?: ToastOptions) {
        toast.error(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            style: {
                backgroundColor: "#000",
                color: "#fff",
            },
            theme: "colored",
            ...options,
        });
    }

    warning(message: string, options?: ToastOptions) {
        toast.warning(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            style: {
                backgroundColor: "#000",
                color: "#fff",
            },
            theme: "colored",
            ...options,
        });
    }

    info(message: string, options?: ToastOptions) {
        toast.info(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            style: {
                backgroundColor: "#fff",
                color: "#000",
                boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
            },
            theme: "colored",
            ...options,
        });
    }
}

const toastifyInstance = new Toastify();

export default toastifyInstance;